import React from 'react';
import LogoMark from './LogoMark';

function AboutPage({ onClose, colors, fonts }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "2rem",
        overflow: "auto"
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: "20px",
          maxWidth: "800px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          padding: "3rem",
          fontFamily: fonts.body,
          position: "relative"
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "1.5rem",
            right: "1.5rem",
            background: "transparent",
            border: "none",
            fontSize: "1.5rem",
            color: colors.brownGray,
            cursor: "pointer",
            padding: "0.5rem"
          }}
        >
          ×
        </button>

        <div style={{ textAlign: "center", marginBottom: "3rem" }}>
          <div style={{ marginBottom: "1.5rem" }}>
            <LogoMark width={240} height={96} />
          </div>
          <h1
            style={{
              fontSize: "2.5rem",
              fontFamily: fonts.display,
              color: colors.charcoal,
              marginBottom: "1rem"
            }}
          >
            About The Single Loop
          </h1>
          <p style={{
            fontSize: "1.2rem",
            color: colors.darkGray,
            fontStyle: "italic"
          }}>
            Every great project starts with a single loop.
          </p>
        </div>

        <div style={{ marginBottom: "2rem" }}>
          <h2 style={{
            fontSize: "1.5rem",
            color: colors.charcoal,
            marginBottom: "1rem",
            fontWeight: "700"
          }}>
            Our Story
          </h2>
          <p style={{
            color: colors.darkGray,
            lineHeight: "1.8",
            fontSize: "1.05rem",
            marginBottom: "1rem"
          }}>
            You've found the perfect pattern. Now comes the hard part: Will that beautiful sage green
            yarn you fell in love with actually work? Should you go with cotton or acrylic? How will
            those colors look together? And if you want to make it bigger, how much more yarn do you need?
          </p>
          <p style={{
            color: colors.darkGray,
            lineHeight: "1.8",
            fontSize: "1.05rem",
            marginBottom: "1rem"
          }}>
            The Single Loop was born from these real-world design questions that every crocheter faces.
            We built this platform to bridge the gap between finding a pattern and actually bringing
            your vision to life—with the colors you love, the yarn that fits your project, and the
            confidence that it'll all work together beautifully.
          </p>
        </div>

        <div style={{
          background: colors.bgCream,
          padding: "2rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          borderLeft: `4px solid ${colors.sageGreen}`
        }}>
          <h2 style={{
            fontSize: "1.3rem",
            color: colors.charcoal,
            marginBottom: "1rem",
            fontWeight: "700"
          }}>
            Our Mission
          </h2>
          <p style={{
            color: colors.darkGray,
            lineHeight: "1.8",
            fontSize: "1.05rem",
            margin: 0
          }}>
            To connect crocheters with talented designers, free patterns & crochet content, and empower them to make each project uniquely their own.
          </p>
        </div>

        <div style={{ marginBottom: "2rem" }}>
          <h2 style={{
            fontSize: "1.5rem",
            color: colors.charcoal,
            marginBottom: "1.5rem",
            fontWeight: "700"
          }}>
            What We Offer
          </h2>

          <div style={{ display: "grid", gap: "1.5rem" }}>
            {[
              {
                icon: "🎨",
                title: "Color Planning",
                text: "Visualize color palettes and see curated combinations that work beautifully together before you buy a single skein."
              },
              {
                icon: "🧶",
                title: "Yarn Selection",
                text: "\"Will this yarn work?\" See exactly what yarn weight and material each pattern needs, plus suggestions for specific yarns."
              },
              {
                icon: "🔍",
                title: "Curated Discovery",
                text: "We collect quality free patterns from talented designers across the web and organize them with the details that matter."
              },
              {
                icon: "💡",
                title: "Design Confidence",
                text: "Stop second-guessing your choices. Plan your entire project—colors, yarn, size—before you pick up your hook."
              }
            ].map((item, idx) => (
              <div key={idx} style={{
                display: "flex",
                gap: "1rem",
                alignItems: "start"
              }}>
                <div style={{ fontSize: "2rem", flexShrink: 0 }}>{item.icon}</div>
                <div>
                  <h3 style={{
                    fontSize: "1.1rem",
                    color: colors.charcoal,
                    marginBottom: "0.5rem",
                    fontWeight: "700"
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    color: colors.darkGray,
                    lineHeight: "1.6",
                    margin: 0
                  }}>
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{
          background: colors.bgCream,
          padding: "1.5rem",
          borderRadius: "12px",
          marginBottom: "2rem"
        }}>
          <h3 style={{
            fontSize: "1.2rem",
            color: colors.charcoal,
            marginBottom: "0.75rem",
            fontWeight: "700"
          }}>
            💚 Supporting Pattern Designers
          </h3>
          <p style={{
            color: colors.darkGray,
            lineHeight: "1.7",
            margin: 0
          }}>
            Every pattern on The Single Loop links directly to the original designer's site.
            We celebrate and credit the talented crocheters who generously share their work for free,
            and we encourage our community to support them by following their instructions,
            respecting their terms, and sharing their creations.
          </p>
        </div>

        <div style={{
          background: `linear-gradient(135deg, ${colors.sageGreen} 0%, #8e9775 100%)`,
          padding: "2rem",
          borderRadius: "12px",
          textAlign: "center",
          color: "#fff"
        }}>
          <h3 style={{
            fontSize: "1.3rem",
            marginBottom: "1rem",
            fontWeight: "700"
          }}>
            Get in Touch
          </h3>
          <p style={{ marginBottom: "1.5rem", opacity: 0.9 }}>
            Have feedback, suggestions, or a pattern you'd love to see added?
          </p>
          <a
            href="mailto:andrea@thesingleloop.com"
            style={{
              display: "inline-block",
              padding: "0.75rem 2rem",
              background: "#fff",
              color: colors.sageGreen,
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "1rem"
            }}
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
